import image1 from '../assets/images/goals/1.png';
import image2 from '../assets/images/goals/2.png';
import image3 from '../assets/images/goals/3.png';
import image4 from '../assets/images/goals/4.png';
import image5 from '../assets/images/goals/5.png';
import image6 from '../assets/images/goals/6.png';
import image7 from '../assets/images/goals/7.png';
import image8 from '../assets/images/goals/8.png';
import image9 from '../assets/images/goals/9.png';
import image10 from '../assets/images/goals/10.png';
import image11 from '../assets/images/goals/11.png';
import image12 from '../assets/images/goals/12.png';
import image13 from '../assets/images/goals/13.png';
import image14 from '../assets/images/goals/14.png';
import image15 from '../assets/images/goals/15.png';
import image16 from '../assets/images/goals/16.png';
import image17 from '../assets/images/goals/17.png';

export function truncateText(text: string, maxLength: number) {
  if (text && text.length > maxLength) {
    return text.slice(0, maxLength) + '...';
  }
  return text;
}

export function formatCurrency(value: string | number): string {
  if (value === undefined || value === null) return '';
  if (typeof value === 'number') {
    return value.toLocaleString('en-US');
  } else if (typeof value === 'string') {
    const numberValue = parseFloat(value);
    if (!isNaN(numberValue)) {
      return numberValue.toLocaleString('en-US');
    }
  }
  return value.toString();
}

export const renderGoalImage = (goal: string) => {
  switch (goal) {
    case '1':
      return image1;

    case '2':
      return image2;

    case '3':
      return image3;

    case '4':
      return image4;

    case '5':
      return image5;

    case '6':
      return image6;

    case '7':
      return image7;

    case '8':
      return image8;

    case '9':
      return image9;

    case '10':
      return image10;

    case '11':
      return image11;

    case '12':
      return image12;

    case '13':
      return image13;

    case '14':
      return image14;

    case '15':
      return image15;

    case '16':
      return image16;

    case '17':
      return image17;

    default:
      return image1;
  }
};

export const renderGoalHeading = (goal: string) => {
  switch (goal) {
    case '1':
      return 'No Poverty';

    case '2':
      return 'Zero Hunger';

    case '3':
      return 'Good Health and well being';

    case '4':
      return 'Quality Education';

    case '5':
      return 'Gender Equality';

    case '6':
      return 'Clean Water and Sanitation';

    case '7':
      return 'Affordable and Clean Energy';

    case '8':
      return 'Decent Work and Economic Growth';

    case '9':
      return 'Industry, Innovation and Infrastructure';

    case '10':
      return 'Reduced Inequalities';

    case '11':
      return 'Sustainable Cities and Communities';

    case '12':
      return 'Responsible Consumption and Production';

    case '13':
      return 'Climate Action';

    case '14':
      return 'Life Below Water';

    case '15':
      return 'Life on Land';

    case '16':
      return 'Peace, Justice and Strong Institutions';

    case '17':
      return 'Partnerships for the Goals';

    default:
      return 'No Poverty';
  }
};

export const renderGoalSubHeading = (goal: string) => {
  switch (goal) {
    case '1':
      return 'End poverty in all its forms everywhere';

    case '2':
      return 'End hunger, achieve food security and improved nutrition and promote sustainable agriculture';

    case '3':
      return 'Ensure healthy lives and promote well-being for all at all ages';

    case '4':
      return 'Ensure inclusive and equitable quality education and promote lifelong learning opportunities for all';

    case '5':
      return 'Achieve gender equality and empower all women and girls';

    case '6':
      return 'Ensure availability and sustainable management of water and sanitation for all';

    case '7':
      return 'Ensure access to affordable, reliable, sustainable and modern energy for all';

    case '8':
      return 'Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work for all';

    case '9':
      return 'Build resilient infrastructure, promote inclusive and sustainable industrialization and foster innovation';

    case '10':
      return 'Reduce inequality within and among countries';

    case '11':
      return 'Make cities and human settlements inclusive, safe, resilient and sustainable';

    case '12':
      return 'Ensure sustainable consumption and production patterns';

    case '13':
      return 'Take urgent action to combat climate change and its impacts';

    case '14':
      return 'Conserve and sustainably use the oceans, seas and marine resources for sustainable development';

    case '15':
      return 'Protect, restore and promote sustainable use of terrestrial ecosystems, sustainably manage forests, combat desertification, and halt and reverse land degradation and halt biodiversity loss';

    case '16':
      return 'Promote peaceful and inclusive societies for sustainable development, provide access to justice for all and build effective, accountable and inclusive institutions at all levels';

    case '17':
      return 'Strengthen the means of implementation and revitalize the global partnership for sustainable development';

    default:
      return 'End poverty in all its forms everywhere';
  }
};

export const truncateLinks = (inputString: string) => {
  const first = inputString.slice(0, 20);
  const last = inputString.slice(-30);
  const truncatedString = `${first}...${last}`;
  return truncatedString;
};
